import { useCallback, useState } from 'react';

type UseTabs<T> = {
  currentTab: T[keyof T];
  handleTabChange: (tab: T[keyof T]) => void;
};

export function useTabs<T extends Record<string, string>>(initialTab: T[keyof T]): UseTabs<T> {
  const [currentTab, setCurrentTab] = useState<T[keyof T]>(initialTab);

  const handleTabChange = useCallback((tab: T[keyof T]) => {
    setCurrentTab(tab);
  }, []);

  return {
    currentTab,
    handleTabChange,
  };
}
